import { Index } from 'flexsearch';
import { AevoIcon } from '../../../ngx-aevo-icons/src/lib/icons/icons';

export class FullTextSearch {
    private readonly itemByIndex = new Map<number, AevoIcon>();
    private readonly ftsIndex = new Index({
        charset: 'latin:advanced',
        tokenize: 'full',
        cache: true,
    });

    constructor(private readonly dataset: AevoIcon[]) {
        dataset.forEach((icon, index) => {
            this.ftsIndex.add(index, icon.name);
            this.itemByIndex.set(index, icon);
        });
    }

    filter(text: string): AevoIcon[] {
        const results = this.ftsIndex.search(text, { suggest: true });
        return results.map((id) => this.itemByIndex.get(+id)!);
    }
}
